/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CaseCloserNotFound/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import Tysiav2Warning from 'DesignSystem/Svgs/Tysiav2Warning/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function CaseCloserNotFound({
  children,
  viewPath = "/App/CaseCloserNotFound"
  
}) {
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="CaseCloserNotFound.Vertical"
  data-view-path={viewPath}
 style={{'--bc-1-Z2nRIFI': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="small"
 className="new-shadow"
 className="new-shadow"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingBottom={dtSpaceL}
 paddingTop={dtSpaceL}
 justifyContent="center"
 alignItems="center"
>
{childProps => (
<div
  data-testid="CaseCloserNotFound.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Tysiav2Warning
  viewPath={`${viewPath}/Tysiav2Warning`}
 height={dtSpaceL}
 width={dtSpaceL}
/>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 textAlign="center"
 marginTop={dtSpaceS}
 level="h5"
 whiteSpace="normal"
 text="No record of a Case Closer to open. Please contact the clinic to set one up."
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
</div>
{children}
</React.Fragment>)
}